import { render, staticRenderFns } from "./OverLimitSettings.vue?vue&type=template&id=1f0c7e44&scoped=true&"
import script from "./OverLimitSettings.vue?vue&type=script&lang=js&"
export * from "./OverLimitSettings.vue?vue&type=script&lang=js&"
import style0 from "./OverLimitSettings.vue?vue&type=style&index=0&id=1f0c7e44&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f0c7e44",
  null
  
)

export default component.exports